import React, { Fragment } from "react";
// import { makeStyles } from "@material-ui/styles";
import Apiconsole from "./apiconsole/apiconsole";

// const useStyle = makeStyles((theme) => ({
//   root: { height: "100%", width: "100%" },
// }));
const Backend = (props) => {
  // const classes = useStyle();
  // const { history } = useReactRouter();

  return (
    <Fragment>
      <Apiconsole />
    </Fragment>
  );
};

export default Backend;
